<template>
  <main role="main">
    <div class="container padding-y-4xl">
      <article class="card roomy">
        <font-awesome-icon
          :icon="$v6.duotone.faFaceSurprise"
          size="4x"
          style="--fa-secondary-opacity: 1; --fa-primary-color: var(--fa-navy); --fa-secondary-color: var(--fa-yellow)"
        />
        <h1 class="margin-y-2xs">Zoinks!</h1>

        <p class="size-lg laptop:column-8 laptop:offset-2">
          We couldn't find a category named &ldquo;{{ titleCase(category) }}&rdquo;, but we do have {{ categoriesCount }} other categories.
        </p>

        <site-link
          :to="{ name: 'latest.icons.categories' }"
          class="button margin-y-lg"
          style="--link-decoration-style: none; --link-decoration-line: none; --tag-link-hover-color: var(--fa-navy)"
        >
          View All Categories
          <font-awesome-icon
            :icon="$v6.solid.faGrid2"
            fixed-width
            class="margin-left-xs"
          />
        </site-link>
      </article>
    </div>
  </main>
</template>

<script>
  import startCase from 'lodash/startCase'

  export default {
    name: 'CategoryNotFound',

    props: {
      category: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      categoriesCount: {
        type: Number
      }
    },

    methods: {
      titleCase(value) {
        return startCase(value)
      }
    }
  }
</script>
